import { BrowserRouter, Routes, Route } from "react-router-dom";
import KYLDashboardPage from "./pages/kyl_dashboard";
import LEHomepage from "./pages/LE_homepage";
import LandscapeExplorer from "./pages/LandscapeExplorer";
import PlansPage from "./pages/PlansPage";
import PlanViewPage from "./pages/PlanViewPage";
import AgroHorticulture from "./pages/AgroHorticulture";
import RWBDashboard from "./pages/RWBDashboard";
import EmbedDashboard from "./components/embed_dashboards";
import { Toaster } from "react-hot-toast";
import StewardDetailPage from "./components/steward_detailPage.jsx";

//import DEMContourMap from "./pages/DemContourMap"

function App() {
  return (
    <BrowserRouter>
    <Toaster position="top-right" />
      <Routes>
        
        <Route path="/" element={<LEHomepage />} />
        <Route path="/kyl_dashboard" element={<KYLDashboardPage />} />
        <Route path="/explore_data" element={<LandscapeExplorer />} />
        <Route path="/agrohorticulture" element={<AgroHorticulture />} />
        <Route path="/rwb" element={<RWBDashboard />} />
        <Route path="/landscape-stewardship" element={<PlansPage />} />
        <Route path="/landscape-stewardship/plan-view" element={<PlanViewPage />} />
        <Route path="/landscape-stewardship/steward-view/:organization/:facilitator" element={<StewardDetailPage />} />
        <Route path="/dashboard/:dashboardType" element={<EmbedDashboard />}
/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
